import React, { useState } from 'react'
import { Modal, Button, Form, Spinner } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useAuth } from '../../context/AuthContext'

const FileUploadModal = ({ show, onHide, onUpload, fileKinds }) => {
    const { getAppLookupValue } = useAuth()
    const [selectedFile, setSelectedFile] = useState(null)
    const [fileKindId, setFileKindId] = useState('')
    const [notes, setNotes] = useState('')
    const [uploading, setUploading] = useState(false)

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        if (file) {
            if (file.size > 10 * 1024 * 1024) { // 10MB limit
                toast.error('Το μέγεθος του αρχείου δεν μπορεί να υπερβαίνει τα 10MB')
                e.target.value = null
                return
            }
            setSelectedFile(file)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!selectedFile || !fileKindId) {
            toast.error('Παρακαλώ επιλέξτε αρχείο και τύπο αρχείου')
            return
        }

        setUploading(true)
        try {
            // Convert file to base64
            const reader = new FileReader()
            reader.onload = async () => {
                const base64Data = reader.result.split(',')[1]
                const formData = {
                    fileKindId: parseInt(fileKindId, 10),
                    fileName: selectedFile.name,
                    fileContent: base64Data,
                    notes: notes
                }

                const response = await onUpload(formData)
                if (!response?.data?.IsSuccess) {
                    setUploading(false)
                }
            }
            reader.readAsDataURL(selectedFile)
        } catch (err) {
            console.error('Error uploading file:', err)
            toast.error('Αποτυχία μεταφόρτωσης αρχείου')
            setUploading(false)
        }
    }

    const handleClose = () => {
        setSelectedFile(null)
        setFileKindId('')
        setNotes('')
        onHide()
    }

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Μεταφόρτωση Αρχείου</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Τύπος Αρχείου</Form.Label>
                        <Form.Select
                            value={fileKindId}
                            onChange={(e) => setFileKindId(e.target.value)}
                            required
                            disabled={uploading}
                            isInvalid={!fileKindId}
                        >
                            <option value="">Επιλέξτε τύπο αρχείου</option>
                            {fileKinds.map(kind => (
                                <option key={kind.Code} value={kind.Code}>
                                    {getAppLookupValue('FilesKind', kind.Code)}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Αρχείο</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={handleFileChange}
                            required
                            disabled={uploading}
                            isInvalid={!selectedFile}
                        />
                        <Form.Text className="text-muted">
                            Μέγιστο μέγεθος αρχείου: 10MB
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Σημειώσεις</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            placeholder="Προαιρετικές σημειώσεις για το αρχείο"
                            disabled={uploading}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} disabled={uploading}>
                        Ακύρωση
                    </Button>
                    <Button
                        type="submit"
                        variant="primary"
                        disabled={uploading || !selectedFile || !fileKindId}>
                        {uploading ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Μεταφόρτωση...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-upload me-2" />
                                Μεταφόρτωση
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default FileUploadModal 